<template>
  <section class="web-development">
    <Hero />
    <Pricing />
    <App />
  </section>
</template>

<script>
import { useHead } from "@vueuse/head";
import { defineComponent, computed, reactive } from "vue";
import Hero from "@/components/views/services/web/hero.vue";
import Pricing from "@/components/views/services/web/pricing.vue";
import App from "@/components/views/services/web/app.vue";

export default defineComponent({
  setup() {
    const siteData = reactive({
      title: "Web Development | Zoinix Inter Technology",
      url: "https://zoinix.com/services/web-development",
    });

    useHead({
      title: computed(() => siteData.title),
      meta: [
        {
          name: "og:title",
          content: computed(() => siteData.title),
        },
        {
          name: "tw:title",
          content: computed(() => siteData.title),
        },
        {
          name: "og:url",
          content: computed(() => siteData.url),
        },
        {
          name: "twitter:url",
          content: computed(() => siteData.url),
        },
      ],
    });
  },
  components: { Hero, Pricing, App },
});
</script>
